export default "__VITE_ASSET__DB990aJE__"